import { render, staticRenderFns } from "./CorrelationsPage.vue?vue&type=template&id=4d0fb212&scoped=true"
import script from "./CorrelationsPage.vue?vue&type=script&lang=ts"
export * from "./CorrelationsPage.vue?vue&type=script&lang=ts"
import style0 from "./CorrelationsPage.vue?vue&type=style&index=0&id=4d0fb212&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0fb212",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d0fb212')) {
      api.createRecord('4d0fb212', component.options)
    } else {
      api.reload('4d0fb212', component.options)
    }
    module.hot.accept("./CorrelationsPage.vue?vue&type=template&id=4d0fb212&scoped=true", function () {
      api.rerender('4d0fb212', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/novel/CorrelationsPage.vue"
export default component.exports